import { render, staticRenderFns } from "./send_mail.vue?vue&type=template&id=6d449772&"
import script from "./send_mail.vue?vue&type=script&lang=js&"
export * from "./send_mail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports